import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  checkArray,
  checkNull,
  createSelectOptions,
} from "../../../../../helpers";
import {
  changeSettingValue,
  getReconcileUploadSettings,
  saveReconcileUploadSettings,
} from "../../../../../Redux/actions";
import DraggableList from "../../../../Components/DraggableList";
import RadioInputCon from "../../../../Components/RadioInputCon";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import ErrorContainer from "../../../../Components/ErrorContainer";

const uploadSettingSchema = yup
  .object({
    transaction_date: yup.boolean().required(),
    value_date: yup.boolean().required(),
    statement_date: yup.boolean().required(),
    date_format: yup.string().required(),
    descriptions: yup.string().required(),
    debit_credit_rows: yup.string().required(),
    debit_represent: yup.string().required(),
    debit_credit_format: yup.string().required(),
    provide_bb_or_eb: yup.string().required(),
    columns: yup.string().required(),
  })
  .required();

const FinanceReconcileUploadSettings = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { reconcile_detail, redirect_reconcile_page } = useSelector(
    (state) => state.settingReducer
  );

  useEffect(() => {
    dispatch(changeSettingValue("redirect_reconcile_id", ""));
    dispatch(getReconcileUploadSettings(`/${id}`));
    return () => {
      dispatch(changeSettingValue("redirect_reconcile_id", ""));
      dispatch(changeSettingValue("redirect_reconcile_page", false));
    };
  }, []);

  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (checkNull(reconcile_detail, false)) {
      if (checkNull(reconcile_detail?.reconcole?.columns, false)) {
        const exploadColumn = reconcile_detail?.reconcole?.columns.split(",");
        if (checkArray(exploadColumn)) {
          setColumns(
            exploadColumn.map((col, ind) => ({ id: ind + 1, name: col }))
          );
        }
      }
      const newInputs = { ...uploadSettingInputForm };
      const reconcole = reconcile_detail?.reconcole;
      if (checkNull(reconcole, false)) {
        newInputs.transaction_date = reconcole?.transaction_date == 1 ? 1 : 0;
        newInputs.value_date = reconcole?.value_date == 1 ? 1 : 0;
        newInputs.statement_date = reconcole?.statement_date == 1 ? 1 : 0;
        newInputs.date_format = checkNull(reconcole?.date_format, false)
          ? reconcole?.date_format
          : newInputs.date_format;
        newInputs.descriptions = checkNull(reconcole?.descriptions, false)
          ? reconcole?.descriptions
          : newInputs.date_format;
        newInputs.debit_credit_rows = checkNull(
          reconcole?.debit_credit_rows,
          false
        )
          ? reconcole?.debit_credit_rows
          : newInputs.date_format;
        newInputs.debit_represent = checkNull(reconcole?.debit_represent, false)
          ? reconcole?.debit_represent
          : newInputs.date_format;
        newInputs.debit_credit_format = checkNull(
          reconcole?.debit_credit_format,
          false
        )
          ? reconcole?.debit_credit_format
          : newInputs.date_format;
        newInputs.provide_bb_or_eb = checkNull(
          reconcole?.provide_bb_or_eb,
          false
        )
          ? reconcole?.provide_bb_or_eb
          : newInputs.date_format;
      }
      resetUploadSettingHandler(newInputs);
    }
  }, [reconcile_detail]);

  const changeColOrderHandler = useCallback((list) => {
    if (checkArray(list)) {
      const listArr = list.map((itm) => itm?.name ?? "");
      changeUploadSettingInputHandler("columns", listArr.join(","));
    }
  }, []);

  const initialUploadSettingForm = {
    transaction_date: 0,
    value_date: 0,
    statement_date: 0,
    date_format: "",
    descriptions: "",
    debit_credit_rows: "",
    debit_represent: "",
    debit_credit_format: "",
    provide_bb_or_eb: "",
    columns: "",
  };
  const [uploadSettingInputForm, setUploadSettingInputForm] = useState(
    initialUploadSettingForm
  );
  const {
    register: uploadSettingReg,
    formState: { errors: uploadSettingErrors },
    handleSubmit: uploadSettingSubmit,
    control: uploadSettingControl,
    setValue: uploadSettingSetValue,
    reset: uploadSettingReset,
  } = useForm({
    resolver: yupResolver(uploadSettingSchema),
    defaultValues: initialUploadSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const changeUploadSettingInputHandler = (input, val) => {
    uploadSettingSetValue(input, val);
    setUploadSettingInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };

  const resetUploadSettingHandler = (resetVal = initialUploadSettingForm) => {
    setUploadSettingInputForm(resetVal);
    uploadSettingReset(resetVal);
  };

  const uploadSettingSubmitHandler = (data) => {
    data.transaction_date = data.transaction_date ? 1 : 0;
    data.value_date = data.value_date ? 1 : 0;
    data.statement_date = data.statement_date ? 1 : 0;
    console.log("uploadSettingSubmitHandler", data);
    dispatch(saveReconcileUploadSettings(`/${id}`, data));
  };

  const reconcilePageLink = () => {
    history.push(`/settings/finance/reconcile`);
  };

  useEffect(() => {
    if (redirect_reconcile_page) {
      reconcilePageLink();
    }
  }, [redirect_reconcile_page]);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 reconcile_upload">
          <form onSubmit={uploadSettingSubmit(uploadSettingSubmitHandler)} className="px-0">
            <div className="container px-0">
              <div className="row mx-0">
                <div className="container px-0">
                  <div className="shadowclass">
                    <div className="top-header-sec">
                      <h4 className="event-alert mb-3">
                        Account Upload Settings
                        <div className="clear"></div>
                      </h4>
                    </div>
                    <div class="col-md-8 recouncile-master">
                      <h2 class="label-heading">
                        {" "}
                        <span class="count"> 1 </span> Which of the following
                        date fields does your bank provide?{" "}
                      </h2>
                      <div class="custom_checkboxs">
                        <div class="bullet-sec">
                          <input
                            {...uploadSettingReg("transaction_date")}
                            onClick={() =>
                              changeUploadSettingInputHandler(
                                "transaction_date",
                                !uploadSettingInputForm?.transaction_date
                              )
                            }
                            type="checkbox"
                            name="data[ReconcileSetting][transaction_date]"
                            class="checkbox-rounded datefield"
                            id="transaction_date"
                            checked={
                              uploadSettingInputForm?.transaction_date == 1
                            }
                          />
                          <label class="round-check" for="tans">
                            {" "}
                            Transaction Date{" "}
                          </label>
                        </div>
                        <div class="bullet-sec">
                          <input
                            {...uploadSettingReg("value_date")}
                            onClick={() =>
                              changeUploadSettingInputHandler(
                                "value_date",
                                !uploadSettingInputForm?.value_date
                              )
                            }
                            type="checkbox"
                            name="data[ReconcileSetting][value_date]"
                            class="checkbox-rounded datefield"
                            id="value_date"
                            checked={uploadSettingInputForm?.value_date == 1}
                          />
                          <label class="round-check" for="value">
                            {" "}
                            Value Date{" "}
                          </label>
                        </div>
                        <div class="bullet-sec">
                          <input
                            {...uploadSettingReg("statement_date")}
                            onClick={() =>
                              changeUploadSettingInputHandler(
                                "statement_date",
                                !uploadSettingInputForm?.statement_date
                              )
                            }
                            type="checkbox"
                            name="data[ReconcileSetting][statement_date]"
                            class="checkbox-rounded datefield"
                            id="statement_date"
                            checked={
                              uploadSettingInputForm?.statement_date == 1
                            }
                          />
                          <label class="round-check" for="both">
                            Statement Date
                          </label>
                        </div>
                      </div>
                      <ErrorContainer
                        errors={uploadSettingErrors}
                        name="transaction_date"
                      />
                      <ErrorContainer
                        errors={uploadSettingErrors}
                        name="value_date"
                      />
                      <ErrorContainer
                        errors={uploadSettingErrors}
                        name="statement_date"
                      />
                      <h2 class="label-heading"> Date format? </h2>
                      <div class="input-group select-div col-md-3 ml0">
                        <select
                          {...uploadSettingReg("date_format")}
                          onChange={(e) =>
                            changeUploadSettingInputHandler(
                              "date_format",
                              e?.target?.value ?? ""
                            )
                          }
                          name="data[ReconcileSetting][date_format]"
                          class="required"
                          id="ReconcileSettingDateFormat"
                          value={uploadSettingInputForm?.date_format}
                        >
                          <option value="">Select</option>
                          {createSelectOptions(reconcile_detail?.dateOptions)}
                        </select>{" "}
                        <ErrorContainer
                          errors={uploadSettingErrors}
                          name="date_format"
                        />
                      </div>
                      <div class="clear"> </div>
                      <h2 class="label-heading">
                        {" "}
                        <span class="count"> 2 </span>How many description
                        fields does your bank provide?
                      </h2>

                      <div class="input-group select-div col-md-3 ml0">
                        <select
                          {...uploadSettingReg("descriptions")}
                          onChange={(e) =>
                            changeUploadSettingInputHandler(
                              "descriptions",
                              e?.target?.value ?? ""
                            )
                          }
                          name="data[ReconcileSetting][descriptions]"
                          class="required descs"
                          id="ReconcileSettingDescriptions"
                          value={uploadSettingInputForm?.descriptions}
                        >
                          <option value="">Select</option>
                          {createSelectOptions({ 1: "1", 2: "2" })}
                        </select>{" "}
                        <ErrorContainer
                          errors={uploadSettingErrors}
                          name="descriptions"
                        />
                      </div>
                      <div class="clear"> </div>

                      <h2 class="label-heading">
                        {" "}
                        <span class="count"> 3 </span> Does your bank provide 2
                        separate columns for Debit and Credit amounts or are all
                        amounts in the same field?{" "}
                      </h2>

                      <div class="input-group select-div col-md-3 ml0">
                        <select
                          {...uploadSettingReg("debit_credit_rows")}
                          onChange={(e) =>
                            changeUploadSettingInputHandler(
                              "debit_credit_rows",
                              e?.target?.value ?? ""
                            )
                          }
                          name="data[ReconcileSetting][debit_credit_rows]"
                          class="required descs"
                          id="ReconcileSettingDescriptions"
                          value={uploadSettingInputForm?.debit_credit_rows}
                        >
                          <option value="">Select</option>
                          {createSelectOptions({ No: "No", Yes: "Yes" })}
                        </select>{" "}
                        <ErrorContainer
                          errors={uploadSettingErrors}
                          name="debit_credit_rows"
                        />
                      </div>

                      <h2 class="label-heading">
                        {" "}
                        Does your bank statement’s Debit represent an incoming
                        or outgoing amount?
                      </h2>

                      <RadioInputCon
                        items={[
                          { value: "Incoming", label: "Incoming" },
                          { value: "Outgoing", label: "Outgoing" },
                        ]}
                        value={uploadSettingInputForm?.debit_represent}
                        name={"debit_represent"}
                        onChange={changeUploadSettingInputHandler}
                        className={"checkbox-rounded"}
                      />
                      <ErrorContainer
                        errors={uploadSettingErrors}
                        name="debit_represent"
                      />

                      <h2 class="label-heading">
                        {" "}
                        Which format the bank uses to determine what is a Debit
                        and what is a Credit?
                      </h2>
                      <div class="input-group select-div col-md-3 ml0">
                        <select
                          name="data[ReconcileSetting][debit_credit_format]"
                          class="required dbcolname"
                          id="ReconcileSettingDebitCreditFormat"
                          {...uploadSettingReg("debit_credit_format")}
                          onChange={(e) =>
                            changeUploadSettingInputHandler(
                              "debit_credit_format",
                              e?.target?.value ?? ""
                            )
                          }
                          value={uploadSettingInputForm?.debit_credit_format}
                        >
                          <option value="">Select</option>
                          <option value="Debit / (Credit)">
                            Debit / (Credit)
                          </option>
                        </select>{" "}
                        <ErrorContainer
                          errors={uploadSettingErrors}
                          name="debit_credit_format"
                        />
                      </div>
                      <div class="clear"> </div>

                      <h2 class="label-heading">
                        {" "}
                        <span class="count"> 4 </span> Does your bank provide a
                        Beginning Balance and Ending Balance for each
                        transaction?{" "}
                      </h2>
                      <div class="input-group select-div col-md-3 ml0">
                        <select
                          name="data[ReconcileSetting][provide_bb_or_eb]"
                          class="required dbcolname"
                          id="ReconcileSettingDebitCreditFormat"
                          {...uploadSettingReg("provide_bb_or_eb")}
                          onChange={(e) =>
                            changeUploadSettingInputHandler(
                              "provide_bb_or_eb",
                              e?.target?.value ?? ""
                            )
                          }
                          value={uploadSettingInputForm?.provide_bb_or_eb}
                        >
                          <option value="">Select</option>
                          {createSelectOptions({ No: "No", Yes: "Yes" })}
                        </select>{" "}
                        <ErrorContainer
                          errors={uploadSettingErrors}
                          name="provide_bb_or_eb"
                        />
                      </div>
                    </div>

                    <div class="upload-settings mt-5">
                      <div className="row mx-0">
                        <h3 class="event-alert mb-0">
                          <a href="#_">Expected Upload Sheet Format</a>{" "}
                          <div class="clear"></div>
                        </h3>
                        <p className="w-100 px-0">
                          <i>
                            You can drag and drop the items to sort them in the
                            correct order.
                          </i>
                        </p>
                      </div>
                    </div>

                    <div class="expected-buttons" id="accordion">
                      {checkArray(columns) && (
                        <DraggableList
                          items={columns}
                          onChangeHandler={changeColOrderHandler}
                        />
                      )}
                    </div>
                    <ErrorContainer
                      errors={uploadSettingErrors}
                      name="columns"
                    />
                  </div>
                </div>
              </div>

              <div className="row mx-0">
                <div className="container px-0 d-flex col-12">
                  <div className="btns col-4 d-flex justify-content-end py-4 col-12">
                    <button id="" type="Submit">
                      Save
                    </button>
                    <button
                      id="cancel"
                      type="button"
                      onClick={() => reconcilePageLink()}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </UserInterface>
  );
};
export default FinanceReconcileUploadSettings;
